import { inject, Injector, runInInjectionContext } from '@angular/core'

import { firstValueFrom } from 'rxjs'

import { TranslateService } from '@ngx-translate/core'

import { AUTH_STORE_TOKEN } from '../tokens/auth-store.token'

/**
 * Initializes language settings using TranslateService in a safe DI context.
 * Should be called after bootstrapApplication.
 */
export async function initializeLanguage(injector: Injector) {
  await runInInjectionContext(injector, async () => {
    const translate = inject(TranslateService)
    const authStore = inject(AUTH_STORE_TOKEN)

    const userLang = authStore.getUserLanguage()
    const savedLang = localStorage.getItem('lang')
    const browserLang = navigator.language?.split('-')[0]
    const isBrowserLangDifferent = browserLang && browserLang !== 'en'

    let langToUse = 'en'

    if (userLang) {
      langToUse = userLang.split('-')[0]
    } else if (savedLang) {
      langToUse = savedLang.split('-')[0]
    } else if (isBrowserLangDifferent) {
      langToUse = browserLang
    }

    translate.setDefaultLang('en')
    await firstValueFrom(translate.use(langToUse))

    if (localStorage.getItem('lang') !== langToUse) {
      localStorage.setItem('lang', langToUse)
    }
  })
}
